import { render, staticRenderFns } from "./EdCamera.vue?vue&type=template&id=c3645e46&"
import script from "./EdCamera.vue?vue&type=script&lang=js&"
export * from "./EdCamera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports